"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toError = exports.pickChildToRender = void 0;
const react_1 = __importDefault(require("react"));
function pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    if (initializingComponent != null) {
        return react_1.default.createElement(react_1.default.Fragment, null, initializingComponent);
    }
    return null;
}
exports.pickChildToRender = pickChildToRender;
function toError(err) {
    if (err instanceof Error) {
        return err;
    }
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
exports.toError = toError;
